/**
 * Classifies the abort reasons assistant-ui uses when it aborts a
 * ChatModelAdapter run generator. The reason tells apart THREE cases:
 *
 *  - `cancelRun()` (user hits Stop)         → `AbortError{ detach: false }`
 *  - `detach()` (surface unmount/navigation) → `AbortError{ detach: true }`
 *  - internal lifecycle aborts (e.g. `performRoundtrip` aborting "the existing
 *    run" when a new roundtrip starts on the same thread) → plain `abort()`
 *    with NO reason (a DOMException without a `detach` field).
 *
 * Only the explicit user Stop may cancel the run server-side. Treating any
 * non-detach abort as a Stop is what auto-cancelled healthy runs mid-reasoning:
 * an internal abort during a long thinking block (no reasoning_stop yet) sent
 * `{"type":"cancel"}` to the runtime with no user click, killing the run right
 * as it prepared its clarify questions.
 */

/** True iff the abort reason is assistant-ui's explicit user Stop. */
export function isUserStopAbortReason(reason: unknown): boolean {
  return (reason as { detach?: boolean } | null | undefined)?.detach === false;
}

/** True iff the abort reason is assistant-ui's detach (unmount / navigation). */
export function isDetachAbortReason(reason: unknown): boolean {
  return (reason as { detach?: boolean } | null | undefined)?.detach === true;
}
